import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography, Row, Input, Button, Form, Modal } from 'antd';
import { useHistory } from 'react-router-dom';
import { CustomImage, CustomPageHeader, CustomCollapseCard, Text as CustomText, useText } from '@src/components';
import {
  getVehicleList,
  resetCurrentLoadVehicleManagement,
} from '@src/store/slice/vehicleManagementStore/vehicleManagementSlice';
import { resetVehicleLimitWithValueTypes } from '@src/store/slice/addNewCarStore/addCarPlateDetailSlice';
import { moneyFormat } from '@src/utils/utils';
import iconSuccess from '@src/assets/icons/icon-success.svg';

import carWallet from '@src/assets/icons/ticketcar/wallet-money.svg';
import carMoney from '@src/assets/icons/ticketcar/money-remove.svg';
import logoMobilExpress from '@src/assets/images/cardOrders/logo-mobilexpress.webp';
import iconEdit from '@src/assets/icons/edit.svg';
import car from '@src/assets/icons/ticketcar/car.svg';
import carplus from '@src/assets/icons/carplus.svg';
import masterCardLogo from '@src/assets/images/cardOrders/mastercard-logo.svg';
import logoVisa from '@src/assets/images/cardOrders/visa-inc-logo.svg';
import '@src/styles/vehicleManagement/vehicleManagement.scss';
import '@src/styles/addNewCar/addCarPlateInformation.scss';
import '@src/styles/autoUploadInstruction/completed.scss';
import '@src/styles/cardOrder/cardCompleted.scss';
import {
  createFleetLoadBalance,
  createFleetLoadBalanceSuccess,
} from '@src/store/slice/addFleetLimitStore/addFleetLimitSlice';
import NewCreditCards from './NewCreditCards';
import OrderSummary from './OrderSummary';
import { getCardWithVouList } from '@src/store/slice/mobilExpressSlice';
import SavedCreditCards from './SavedCreditCards';
import PaymentModal from '@src/pages/ticketRestaurant/myOrders/PaymentModal';
import { CustomTable } from '@src/components/index';
import CustomIconComponent from '@src/components/CustomIconComponent';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import { getCustomerVouList } from '@src/store/slice/customerSlice';

const { Text } = Typography;

const AddFleetLimit = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { activeVehicles, passiveVehicles, vehicleLimit, vehicleAvailableLimit } = useSelector(
    (state) => state.vehicleManagement,
  );
  const { fleetLoadBalanceId } = useSelector((state) => state.addFleetLimit);

  const { isAdmin } = useSelector((state) => state.auth);
  const { selectedUserId } = useSelector((state) => state.user);
  const { selectedCustomer } = useSelector((state) => state.customer);
  const [isConfirmLimit, setIsConfirmLimit] = useState(false);
  const [isOrderSuccess, setIsOrderSuccess] = useState(false);
  const [errorValue, setErrorValue] = useState(false);
  const [counter, setCounter] = useState(0);
  const [payLater, setPayLater] = useState(false);
  const [notSavedCard, setNotSavedCard] = useState(false);
  const [cardType, setCardType] = useState('savedCreditCards');
  const [value, setValue] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [afterConfirm, setIsAfterConfirm] = useState(false);
  const [columns, setColumns] = useState([]);
  const isMobil = useMediaQuery({ query: '(max-width: 768px)' });
  const [cusVouList, setCusVouList] = useState([]);

  const pleaseEnterTheLimitAmountYouWantTo = useText('pleaseEnterTheLimitAmountYouWantTo');
  const increaseFleetLimit = useText('increaseFleetLimit');
  const thankYou = useText('thankYou');
  const vehicleManagement = useText('vehicleManagement');
  const currentFleetLimit = useText('currentFleetLimit');
  const fleetRemainingLimit = useText('fleetRemainingLimit');
  const activeVehicle = useText('activeVehicle');
  const vehicleToBeAdded = useText('vehicleToBeAdded');
  const limitAmountYouWantToAdd = useText('limitAmountYouWantToAdd');
  const newlyAddedVehicleList = useText('newlyAddedVehicleList');
  const iWantToPayWithMyRegisteredCredit = useText('iWantToPayWithMyRegisteredCredit');
  const iWantToPayWithAnotherCard = useText('iWantToPayWithAnotherCard');
  const setYourNewFleetLimit = useText('setYourNewFleetLimit');
  const fleetLimitIncreaseRequestReceived = useText('fleetLimitIncreaseRequestReceived');
  const fleetLimitUpdateMessage = useText('fleetLimitUpdateMessage');
  const returnToVehicleManagement = useText('returnToVehicleManagement');
  const fleetLimitIncreaseEmailReminder = useText('fleetLimitIncreaseEmailReminder');
  const paymentLinkReminder = useText('paymentLinkReminder');
  const paymentLinkSentSuccessfully = useText('paymentLinkSentSuccessfully');
  const sendPaymentLink = useText('sendPaymentLink');

  const addNewCarValue = history?.location?.state?.addNewCarValue;
  const allPlatesDetailItems = history?.location?.state?.allPlatesDetailItems;
  const [form] = Form.useForm();

  useEffect(() => {
    (async () => {
      const action = await dispatch(getCardWithVouList({ VouId: 4 }));
      if (getCardWithVouList.fulfilled.match(action)) {
        const array = action.payload.data.cardList;
        if (array.length === 0) {
          setNotSavedCard(true);
          setCardType('newCardAddFrom');
        } else {
          setCardType('savedCreditCards');
        }
      } else {
        setCardType('newCardAddFrom');
      }
    })();
  }, [dispatch]);

  const fetchVehicleListData = async () => {
    if (isAdmin && selectedUserId) {
      await dispatch(getVehicleList({ customerId: selectedUserId }));
    } else {
      await dispatch(getVehicleList());
    }
  };

  useEffect(() => {
    fetchVehicleListData();
    return () => {
      dispatch(resetCurrentLoadVehicleManagement());
      dispatch(resetVehicleLimitWithValueTypes());
    };
  }, [dispatch, selectedUserId]);

  useEffect(async () => {
    const vouListAction = await dispatch(
      getCustomerVouList({
        customerId: selectedCustomer?.customerId,
        vouId: 4,
      }),
    );
    if (vouListAction?.payload?.data) {
      setCusVouList(vouListAction.payload.data);
    }
  }, [dispatch, selectedCustomer]);

  useEffect(() => {
    if (isOrderSuccess) fetchVehicleListData();
  }, [isOrderSuccess]);

  useEffect(async () => {
    if (addNewCarValue) {
      try {
        setValue(addNewCarValue);
        const data = {
          totalPrice: parseInt(addNewCarValue.toString().replaceAll('.', ''), 10),
          vouId: 4,
        };
        await dispatch(createFleetLoadBalance({ data }));
        setIsConfirmLimit(true);
      } catch (error) {
        console.error('addNewCarValue', error);
      }
    }
  }, [addNewCarValue]);

  useEffect(() => {
    if (allPlatesDetailItems) {
      let tempColumns = [
        {
          title: '#',
          dataIndex: 'id',
          key: 'id',
          fixed: 'left',
          align: 'center',
          width: 40,
          height: 50,
        },
        {
          title: <Text t="licensePlate" />,
          dataIndex: 'plateNumber',
          key: 'plateNumber',
          align: 'left',
          width: 90,
          height: 50,
        },
        {
          title: <Text t="limit" />,
          dataIndex: 'limitValue',
          key: 'limitValue',
          align: 'left',
          width: 70,
          height: 50,
          render: (_, record) => {
            if (record.limitDetails?.limitValue) {
              return (
                record.limitDetails?.limitValue +
                (record.limitDetails?.limitValueType?.name === 'Tutar' ? ' ₺' : ' lt')
              );
            }
            return '';
          },
        },
      ];
      if (!isMobil) {
        tempColumns = tempColumns.concat([
          {
            title: <Text t="provider2" />,
            dataIndex: 'vouId',
            key: 'vouId',
            align: 'left',
            width: 70,
            height: 50,
            render: (_, record) => {
              const vouId = record.selectCustomerVousList?.vouId;
              const IconComponent = CustomIconComponent({ providerType: vouId });

              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {IconComponent && (
                    <img
                      src={IconComponent}
                      alt={record.selectCustomerVousList?.vouName}
                      style={{ width: 24, height: 24, marginRight: 8 }}
                    />
                  )}
                </div>
              );
            },
          },
          {
            title: <Text t="vehicleType2" />,
            dataIndex: 'name',
            key: 'name',
            align: 'left',
            width: 80,
            height: 50,
            render: (_, record) => record.vehicleDetails?.vehicleType?.name,
          },
          {
            title: <Text t="vehicleQualification2" />,
            dataIndex: 'name',
            key: 'name',
            align: 'left',
            width: 90,
            height: 50,
            render: (_, record) => record.vehicleDetails?.attribute?.name,
          },
          {
            title: <Text t="fuelType" />,
            dataIndex: 'name',
            key: 'name',
            align: 'left',
            width: 90,
            height: 50,
            render: (_, record) => record.vehicleDetails?.vehicleFuelType?.name,
          },
          {
            title: <Text t="driverName2" />,
            dataIndex: 'driverName',
            key: 'driverName',
            align: 'left',
            width: 100,
            height: 50,
            render: (_, record) => record.driverDetails?.driverName,
          },
          {
            title: <Text t="driverPhone" />,
            dataIndex: 'driverPhone',
            key: 'driverPhone',
            align: 'left',
            width: 120,
            height: 50,
            render: (_, record) => {
              const phone = record.driverDetails?.driverPhone;
              const formattedPhone = phone
                ? phone.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '0($1) $2 $3 $4')
                : '';
              return formattedPhone;
            },
          },
        ]);
      }
      setColumns(tempColumns);
    }
  }, [allPlatesDetailItems]);

  const confirmAddFleetLimit = async () => {
    if (value?.length > 0 && parseInt(value, 10) > 0) {
      const data = {
        totalPrice: parseInt(value.replaceAll('.', ''), 10),
        vouId: 4,
      };
      await dispatch(createFleetLoadBalance({ data }));
      setIsConfirmLimit(true);
    } else {
      setErrorValue(true);
    }
  };

  const cancelAddFleetLimit = () => {
    history.goBack();
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    if (/^(\d+([.,]\d*)?)?$/.test(inputValue)) {
      setValue(inputValue);
      if (errorValue) setErrorValue(false);
    }
  };

  const redirectToHomePage = () => {
    history.push(
      isAdmin
        ? {
          pathname: '/admin/ticket-car/management-car-processes',
          state: { newActiveKey: '1' },
        }
        : '/ticket-car/vehicle-management',
    );
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsAfterConfirm(false);
  };

  const handleOk = async (body) => {
    if (afterConfirm) {
      setIsAfterConfirm(false);
      redirectToHomePage();
    } else {
      const orderRes = await dispatch(
        createFleetLoadBalanceSuccess({
          data: {
            id: fleetLoadBalanceId,

            customerId: selectedCustomer?.customerId,

            mobilExpressIsPayment: 0,

            paymentType: 4,

            paymentLater: true,

            pendingApproval: false,

            sendMail: true,
            email: body?.emailAddress,
            orderStatus: 100,
            vouId: 4,
          },
        }),
      );
      if (orderRes?.payload?.isSuccess) {
        setIsAfterConfirm(true);
      } else {
        setIsAfterConfirm(false);
        console.error('orderRes?.payload', orderRes?.payload);
      }
    }
    setIsModalVisible(false);
  };

  function formatCurrency(value) {
    const formattedValue = new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 0,
    }).format(value);
    return formattedValue.replace('₺', '') + '₺';
  }

  const content = () => {
    return (
      <>
        <div className="vehicle-management" data-testid="vehicle-management-loading-id">
          <div className="summary-container">
            <div className="summary-info">
              <div className="transaction-icon">
                <CustomImage src={carWallet} />
              </div>
              <div className="summary-right-section">
                <span className="summary-subinfo">{currentFleetLimit}</span>
                <span className="summary-status">{moneyFormat(vehicleLimit)}₺</span>
              </div>
            </div>
          </div>
          {!allPlatesDetailItems?.length > 0 &&
            !cusVouList?.filter(
              (item) =>
                (isAdmin ? selectedUserId : selectedCustomer?.customerId ?? '').toString() ===
                item.customerId.toString() && item.patId === 2,
            )?.length > 0 && (
              <div className="summary-container">
                <div className="summary-info">
                  <div className="transaction-icon" style={{ backgroundColor: '#ffeeed' }}>
                    <CustomImage src={carMoney} />
                  </div>
                  <div className="summary-right-section">
                    <span className="summary-subinfo">{fleetRemainingLimit}</span>
                    <span className="summary-status">{moneyFormat(vehicleAvailableLimit)}₺</span>
                  </div>
                </div>
              </div>
            )}

          <div className="summary-container">
            <div className="summary-info">
              <div className="transaction-icon" style={{ backgroundColor: '#d1fadf' }}>
                <CustomImage src={car} />
              </div>
              <div className="summary-right-section">
                <span className="summary-subinfo">{activeVehicle}</span>
                <span className="summary-status">
                  {activeVehicles}/{activeVehicles + passiveVehicles}
                </span>
              </div>
            </div>
          </div>
          {allPlatesDetailItems?.length > 0 && (
            <div className="summary-container">
              <div className="summary-info">
                <div className="transaction-icon" style={{ backgroundColor: '#ffecf0' }}>
                  <CustomImage src={carplus} />
                </div>
                <div className="summary-right-section">
                  <span className="summary-subinfo">{vehicleToBeAdded}</span>
                  <span className="summary-status">{allPlatesDetailItems.length}</span>
                </div>
              </div>
            </div>
          )}
          <div
            className="summary-container"
            style={{ backgroundColor: 'transparent', borderWidth: 0 }}
          ></div>
        </div>

        <div className="balance-report-header-tools"></div>

        {allPlatesDetailItems && (
          <CustomCollapseCard className="add-new-car-order-summary">
            <div className="balance-report-header-tools">
              <Text>{newlyAddedVehicleList}</Text>
            </div>
            <CustomTable
              pagination={false}
              dataSource={allPlatesDetailItems}
              columns={columns}
              className="babs-list-table"
              rowKey={(record) => `add-new-car-order-summary-list-${record?.id}`}
            />
          </CustomCollapseCard>
        )}
        {!isOrderSuccess && (
          <div
            className="add-car-plateInformation-content"
            data-testid="add-car-plate-information-component"
          >
            <Row justify={'center'} className="header-row-title">
              <span>{setYourNewFleetLimit}</span>
            </Row>
            <CustomCollapseCard>
              <div
                className="monthly-order-container"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                }}
              >
                <span>{limitAmountYouWantToAdd}</span>
                {isConfirmLimit ? (
                  <div
                    className="vehicle-managemet-add-fleet-limit-input"
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      width: 340,
                      marginTop: 20,
                      marginBottom: 20,
                    }}
                  >
                    <span style={{ flex: 1 }}>
                      {formatCurrency(value ? parseInt(value.replaceAll('.', ''), 10) : 0)}
                    </span>
                    <button
                      style={{ color: '#1d2128', display: 'flex', gap: 5 }}
                      className="vehicle-managemet-add-fleet-limit-other-card-text"
                      onClick={() => setIsConfirmLimit(false)}
                    >
                      <CustomImage src={iconEdit} />
                      <CustomText t="edit2" />
                    </button>
                  </div>
                ) : (
                  <Input
                    data-testid={`fleet-limit-input`}
                    placeholder={pleaseEnterTheLimitAmountYouWantTo}
                    className={`vehicle-managemet-add-fleet-limit-input ${errorValue ? 'vehicle-managemet-add-fleet-limit-input-error' : ''
                      }`}
                    onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
                    onChange={handleChange}
                    maxLength={10}
                    value={value}
                    style={{
                      flex: '1 1 auto',
                      width: 340,
                      marginTop: 20,
                      marginBottom: 20,
                      borderColor: errorValue ? 'red' : '#94a3b8',
                    }}
                  />
                )}

                {!isConfirmLimit && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'row',
                      justifyContent: 'center',
                      gap: 20,
                    }}
                  >
                    <button
                      onClick={() => {
                        setValue('15.000');
                        if (errorValue) setErrorValue(false);
                      }}
                      className="vehicle-managemet-add-fleet-limit-badge"
                    >
                      15.000 TL
                    </button>
                    <button
                      onClick={() => {
                        setValue('20.000');
                        if (errorValue) setErrorValue(false);
                      }}
                      className="vehicle-managemet-add-fleet-limit-badge"
                    >
                      20.000 TL
                    </button>
                    <button
                      onClick={() => {
                        setValue('25.000');
                        if (errorValue) setErrorValue(false);
                      }}
                      className="vehicle-managemet-add-fleet-limit-badge"
                    >
                      25.000 TL
                    </button>
                    <button
                      onClick={() => {
                        setValue('30.000');
                        if (errorValue) setErrorValue(false);
                      }}
                      className="vehicle-managemet-add-fleet-limit-badge"
                    >
                      30.000 TL
                    </button>
                    <button
                      onClick={() => {
                        setValue('35.000');
                        if (errorValue) setErrorValue(false);
                      }}
                      className="vehicle-managemet-add-fleet-limit-badge"
                    >
                      35.000 TL
                    </button>
                  </div>
                )}
                {!isConfirmLimit && (
                  <div
                    className="footer-content"
                    style={{ marginTop: 20, display: 'flex', flexDirection: 'column' }}
                  >
                    <Button
                      id="redirect"
                      data-testid="redirect"
                      onClick={confirmAddFleetLimit}
                      className="btn-blue"
                    >
                      <span><CustomText t="approveAndProceedToPayment2" /></span>
                    </Button>
                    <button
                      style={{
                        borderWidth: 0,
                        backgroundColor: 'transparent',
                        textDecoration: 'underline',
                        marginTop: 10,
                      }}
                      data-testid="cancel-add-fleet-limit-id"
                      onClick={cancelAddFleetLimit}
                    >
                      <CustomText t="giveUp" /></button>
                  </div>
                )}
              </div>
            </CustomCollapseCard>
          </div>
        )}
        {!isOrderSuccess && isConfirmLimit && (
          <div
            className="add-car-plateInformation-content"
            data-testid="add-car-plate-information-component"
          >
            <Row
              className="header-row-title"
              style={{ paddingLeft: 20, paddingRight: 20, justifyContent: 'space-between' }}
            >
              <span><CustomText t="savedCreditCardsTitle" /></span>
              {!notSavedCard && (
                <button
                  onClick={() =>
                    cardType === 'newCardAddFrom'
                      ? setCardType('savedCreditCards')
                      : setCardType('newCardAddFrom')
                  }
                  className="vehicle-managemet-add-fleet-limit-other-card-text"
                >
                  {cardType === 'newCardAddFrom'
                    ? iWantToPayWithMyRegisteredCredit
                    : iWantToPayWithAnotherCard}
                </button>
              )}
            </Row>
            <CustomCollapseCard>
              <div className="monthly-order-container">
                {cardType === 'savedCreditCards' ? (
                  <SavedCreditCards
                    setPayLater={() => setIsModalVisible(true)}
                    propIsOn={isModalVisible}
                  />
                ) : (
                  <NewCreditCards
                    form={form}
                    counter={counter}
                    setCounter={setCounter}
                    setPayLater={() => setIsModalVisible(true)}
                    propIsOn={isModalVisible}
                  />
                )}
              </div>
            </CustomCollapseCard>
          </div>
        )}

        {!isOrderSuccess && isConfirmLimit && (
          <>
            <OrderSummary
              counter={counter}
              setCounter={setCounter}
              form={form}
              paymentValue={value}
              payLater={payLater}
              formVisible={!(cardType === 'savedCreditCards')}
              setIsOrderSuccess={() => setIsOrderSuccess(true)}
              goBackPayment={cancelAddFleetLimit}
            />
            <hr />
            <div
              className="footer-logo"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row',
                gap: 10,
              }}
            >
              <div
                className="left-logos"
                style={{ display: 'flex', flexDirection: 'row', flex: 1 }}
              >
                <CustomImage
                  className="logoMobil"
                  src={logoMobilExpress}
                  style={{ width: '100px', height: '30px', marginRight: 10 }}
                />
                <span className="vehicle-managemet-add-fleet-limit-save-check-text">
                  <CustomText t="yourCardsAreStoredSecurelyInThePci" />
                </span>
              </div>
              <div
                className="right-logos"
                style={{ display: 'flex', flexDirection: 'row', gap: 10 }}
              >
                <CustomImage src={logoVisa} style={{ width: '40px', height: '30px' }} />
                <CustomImage src={masterCardLogo} style={{ width: '40px', height: '30px' }} />
              </div>
            </div>
          </>
        )}

        {isOrderSuccess && (
          <div
            className="autoUploadInstruction-instruction-completed-content"
            style={{ paddingBottom: 20 }}
          >
            <div className="success-order-header-content">
              <CustomImage src={iconSuccess} />
              <div className="success-order-header-content-title">
                <h1>{thankYou}</h1>
              </div>
              <div
                className="success-order-header-content-subTitle"
                style={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  display: 'flex',
                }}
              >
                <span
                  style={{ textAlign: 'center', fontSize: 22, maxWidth: 900 }}
                >{fleetLimitIncreaseRequestReceived.replaceAll('{{amount}}', moneyFormat(
                  vehicleLimit + Number.parseInt(value?.replace('.', ''), 10),
                ))}</span>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row',
                    gap: 10,
                    maxWidth: 900,
                  }}
                >
                  <div
                    style={{
                      backgroundColor: '#0050ff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                      fontSize: 24,
                      borderRadius: 17,
                      width: 34,
                      height: 34,
                      fontWeight: 'bold',
                    }}
                  >
                    i
                  </div>
                  <span
                    style={{ textAlign: 'center', marginBottom: 0, flex: null, paddingLeft: 0 }}
                  >{fleetLimitUpdateMessage.replaceAll('{{amount}}', moneyFormat(
                    vehicleLimit + parseInt(value?.replace('.', ''), 10),
                  ))}</span>
                </div>
              </div>
            </div>

            <div className="footer-content">
              <Button
                id="redirect"
                data-testid="redirectToHome"
                onClick={redirectToHomePage}
                className="btn-blue"
              >
                <span>{returnToVehicleManagement}</span>
              </Button>
            </div>
          </div>
        )}
        <Modal
          title={
            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              {afterConfirm && (
                <CustomImage src={iconSuccess} style={{ width: '32px', height: '32px' }} />
              )}
              <Text className="add-fleet-limit-title">
                {afterConfirm ? paymentLinkSentSuccessfully : sendPaymentLink}
              </Text>
            </div>
          }
          visible={afterConfirm}
          onCancel={handleCancel}
          style={{
            borderRadius: '8px', // Modal köşelerini yuvarlama
            padding: '12px 14px 40px 39px',
          }}
          footer={
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                paddingLeft: 10,
              }}
            >
              <Button
                key="ok"
                type="primary"
                style={{
                  color: '#efefef',
                  borderRadius: 6,
                  width: 120,
                  height: 38,
                  fontWeight: 'bold',
                }}
                onClick={handleOk}
              >
                {afterConfirm ? <Text t="okBtn" /> : <Text t="approve2" />}
              </Button>
              {!afterConfirm && (
                <Button
                  key="cancel"
                  type="primary"
                  style={{
                    color: '#efefef',
                    borderRadius: 6,
                    width: 120,
                    height: 38,
                    fontWeight: 'bold',
                  }}
                  onClick={handleCancel}
                >
                  <CustomText t="cancel2" />
                </Button>
              )}
            </div>
          }
          centered
        >
          <div className="add-fleet-limit-div">
            <Text className="add-fleet-limit-text">
              {afterConfirm
                ? fleetLimitIncreaseEmailReminder.replaceAll('{{amount}}', moneyFormat(
                  vehicleLimit + Number.parseInt(value?.replace('.', ''), 10),
                ))
                : paymentLinkReminder}
            </Text>
          </div>
        </Modal>

        <PaymentModal
          modalVisible={isModalVisible}
          handleModalVisible={setIsModalVisible}
          fleetLoadBalanceId={fleetLoadBalanceId}
          paymentPage={false}
          sendOrderEmail={handleOk}
        />
      </>
    );
  };

  return (
    <CustomPageHeader
      data-testid="vehicle-management-test-id"
      title={isAdmin ? null : increaseFleetLimit}
      showBreadCrumb={!isAdmin}
      showHelpButton={!isAdmin}
      adminCustomHeaderContent={isAdmin ? 'custom-header-content-subpage' : ''}
      routes={['Ticket Car', vehicleManagement]}
    >
      {content()}
    </CustomPageHeader>
  );
};

export default AddFleetLimit;
